export default __webpack_public_path__ + "c8db14c8ed7bc5c92917929198c859a4.svg";